// extracted by mini-css-extract-plugin
export default {"title":"Grid_title--uBD","headGroups":"Grid_headGroups--Fie","container":"Grid_container--m2y","cybersportContainer":"Grid_cybersportContainer--pUz"};